import React, { useState } from "react";
import { Form, Button, Row, Col, Alert, Spinner } from "react-bootstrap";
import axios from "axios";
import { BASE_URL, HEADERS } from "../../utils/constant";

export default function UserDataDeletionForm() {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    reason: "",
    confirm: false,
  });

  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ ...formData, [name]: type === "checkbox" ? checked : value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.confirm) {
      alert("Please confirm data deletion.");
      return;
    }

    try {
      setLoading(true);

      await axios.delete(`${BASE_URL}/users/public/account-delete/`, {
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          full_name: formData.fullName,
          email: formData.email,
          reason: formData.reason,
        },
      });

      setSubmitted(true);
      setError(null);
    } catch (err) {
      console.error(err);
      setError("Failed to submit request. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <Alert variant="success" className="mt-4 text-center">
        Your data deletion request has been submitted successfully.
        <br />
        Your data will be permanently deleted after verification as per Google
        Play data safety requirements.
      </Alert>
    );
  }

  return (
    <Form
      onSubmit={handleSubmit}
      className="p-4 bg-white border rounded shadow-sm"
    >
      <h4 className="mb-4 text-danger">User Data Deletion Request</h4>

      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Full Name *</Form.Label>
            <Form.Control
              type="text"
              name="fullName"
              value={formData.fullName}
              onChange={handleChange}
              required
            />
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Email *</Form.Label>
            <Form.Control
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </Form.Group>
        </Col>
      </Row>

      <Form.Group className="mb-3">
        <Form.Label>Reason (optional)</Form.Label>
        <Form.Control
          as="textarea"
          rows={3}
          name="reason"
          value={formData.reason}
          onChange={handleChange}
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Check
          type="checkbox"
          name="confirm"
          label="I confirm that I want my data to be permanently deleted."
          checked={formData.confirm}
          onChange={handleChange}
          required
        />
      </Form.Group>

      {error && <Alert variant="danger">{error}</Alert>}

      <div className="text-end">
        <Button type="submit" variant="danger" disabled={loading}>
          {loading ? (
            <>
              <Spinner size="sm" animation="border" className="me-2" />
              Submitting...
            </>
          ) : (
            "Submit Request"
          )}
        </Button>
      </div>
    </Form>
  );
}
